<p-card>
  <p-tabs [value]="-1" scrollable>
    <p-tablist>
      <p-tab [value]="-1">Gesamt</p-tab>
      @for (location of locationService.locations; track location.id) {
        <p-tab [value]="location.id">{{ location.city }}</p-tab>
      }
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel [value]="-1">
        <div class="mt-2">
          <app-pickup-admin-location></app-pickup-admin-location>
        </div>
      </p-tabpanel>
      @for (location of locationService.locations; track location.id) {
        <p-tabpanel [value]="location.id">
          <div class="mt-2">
            <app-pickup-admin-location [locationId]="location.id"></app-pickup-admin-location>
          </div>
        </p-tabpanel>
      }
    </p-tabpanels>
  </p-tabs>
</p-card>
